import React from 'react';

import ArrowDropDownRoundedIcon from '@material-ui/icons/ArrowDropDownRounded';
import styled from 'styled-components';
import { StyledIconButton, StyledTooltip, StyledTypography, VerticallyCenterContainer } from 'styles/common';

import { StyledCloseIcon, StyledIcon } from 'constants/icons';

import { ItemContainer, SelectedCounter } from './styles';

const FilterDisplay = React.forwardRef((props, ref) => {
  const {
    width,
    onClick,
    icon,
    name,
    selectedCount,
    className,
    isDisabled = false,
    onClear,
    filterTooltip = '',
  } = props;
  return (
    <ItemContainer
      className={className}
      width={width}
      justify="space-between"
      ref={ref}
      onClick={onClick}
      disabled={isDisabled}
      style={{ paddingLeft: '1.5rem', paddingRight: '1.5rem', border: '1px solid #eaeaea' }}
    >
      <VerticallyCenterContainer container alignItems="center">
        <StyledIcon color="textSecondary" size="tiny">
          {icon}
        </StyledIcon>
        <StyledTypography
          leftGutter={1}
          display="inline"
          weight={props.weight ?? null}
          color={props.textColor ?? 'textPrimary'}
        >
          {name}
        </StyledTypography>
      </VerticallyCenterContainer>
      <VerticallyCenterContainer container alignItems="center">
        {selectedCount > 0 && (
          <StyledTooltip title={filterTooltip}>
            <SelectedCounter> {selectedCount}</SelectedCounter>
          </StyledTooltip>
        )}

        {onClear && selectedCount > 0 ? (
          <StyledTooltip title="Clear">
            <CustomStyledIconButton
              circular
              color="primary"
              backgroundColor="white"
              borderColor="primary"
              leftGutter
              padding="xLarge"
              onClick={onClear}
            >
              <StyledCloseIcon size="tiniest" color="primary" />
            </CustomStyledIconButton>
          </StyledTooltip>
        ) : null}

        <StyledIcon leftGutter={1} size="smallest" color="textSecondary">
          <ArrowDropDownRoundedIcon />
        </StyledIcon>
      </VerticallyCenterContainer>
    </ItemContainer>
  );
});

export default FilterDisplay;

const CustomStyledIconButton = styled(StyledIconButton)`
  &.MuiIconButton-root.Mui-disabled {
    background-color: #008ef0;
  }
  &.MuiButtonBase-root {
    width: ${(props) => (props.size === 'big' ? '28px' : '24px')};
    height: ${(props) => (props.size === 'big' ? '28px' : '24px')};
  }
`;
